// Shared helpers for the post-login welcome intro-video, used by both the
// WelcomeVideoModal (which shows it) and the Help Center (which lets the user
// re-enable it). Keeping the localStorage key format in one place avoids the
// two call sites drifting apart.
import { WELCOME_ANCHOR } from '../components/helpAnchors';

export { WELCOME_ANCHOR };

// Dismissal is stored per user AND per video id, so swapping the Loom video in
// the admin panel automatically re-shows the refreshed intro.
const dismissKey = (user, videoId) => `netbot:welcomeVideo:dismissed:${user}:${videoId}`;

export function isWelcomeDismissed(user, videoId) {
    if (!user || !videoId) return false;
    try {
        return localStorage.getItem(dismissKey(user, videoId)) === '1';
    } catch {
        return false;
    }
}

export function setWelcomeDismissed(user, videoId, dismissed) {
    if (!user || !videoId) return;
    try {
        if (dismissed) localStorage.setItem(dismissKey(user, videoId), '1');
        else localStorage.removeItem(dismissKey(user, videoId));
    } catch {
        /* localStorage unavailable — preference simply won't persist */
    }
}

// Pick the intro article for the current UI language, falling back to any
// published one so a single-language upload still works.
export function pickWelcomeArticle(list, lang) {
    const arr = Array.isArray(list) ? list : [];
    if (!arr.length) return null;
    const l = String(lang || '').toLowerCase();
    const norm = l.startsWith('ja') || l.startsWith('jp') ? 'jp' : 'en';
    return arr.find((a) => String(a.language || '').toLowerCase() === norm) || arr[0];
}
